var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { html } from 'lit';
import { property } from 'lit/decorators.js';
import { ifDefined } from 'lit/directives/if-defined.js';
import { BlocksElement } from '../../BlocksElement';
import styles from '../icon.styles';
/**
 * MeetingCamera component
 * @csspart base- The component's base wrapper
 */
export class BlocksIconMeetingCamera extends BlocksElement {
    static { this.styles = styles; }
    connectedCallback() {
        super.connectedCallback();
        this.classList.add('cat-icon');
    }
    render() {
        const componentClassName = this.componentClassNames('cat-c-icon', {
            'cat-c-icon--sm': this.size === 'sm',
            'cat-c-icon--lg': this.size === 'lg',
            'cat-c-icon--xl': this.size === 'xl',
            'cat-c-icon--content-strong': this.color === 'content-strong',
            'cat-c-icon--knockout': this.color === 'knockout',
            'cat-c-icon--knockout-brand': this.color === 'knockout-brand',
            'cat-c-icon--information': this.color === 'information',
            'cat-c-icon--success': this.color === 'success',
            'cat-c-icon--warning': this.color === 'warning',
            'cat-c-icon--error': this.color === 'error'
        });
        return html `
      <span part="base" class="${componentClassName}" role="presentation">
        <svg
          aria-hidden="${!this.iconTitle}"
          aria-label="${ifDefined(this.iconTitle)}"
          role="${this.iconTitle && 'img'}"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M3.58398 5.0202C3.0317 5.0202 2.58398 5.46792 2.58398 6.0202V17.9494C2.58398 18.5017 3.03169 18.9494 3.58396 18.9494L14.9325 18.9497C15.4848 18.9497 15.9326 18.502 15.9326 17.9497V15.5897C15.9326 14.9637 16.5863 14.5525 17.1506 14.8235L21.4016 16.8654L21.4016 7.11582L17.1453 9.1816C16.5786 9.45663 15.9201 9.04131 15.9242 8.41145L15.9395 6.02662C15.943 5.47184 15.4943 5.0202 14.9395 5.0202H3.58398ZM1.08398 6.0202C1.08398 4.63949 2.20327 3.5202 3.58398 3.5202H14.9395C16.3265 3.5202 17.4484 4.6493 17.4395 6.03625L17.4309 7.37567L20.7467 5.76636C21.7429 5.28286 22.9016 6.00848 22.9016 7.11583L22.9016 16.8654C22.9016 17.9701 21.7479 18.6958 20.7522 18.2175L17.4326 16.623V17.9497C17.4326 19.3304 16.3132 20.4497 14.9325 20.4497L3.58393 20.4494C2.20324 20.4494 1.08398 19.3301 1.08398 17.9494V6.0202Z"
          />
        </svg>
      </span>
    `;
    }
}
__decorate([
    property({ type: String })
], BlocksIconMeetingCamera.prototype, "color", void 0);
__decorate([
    property({ type: String })
], BlocksIconMeetingCamera.prototype, "iconTitle", void 0);
__decorate([
    property({ type: String })
], BlocksIconMeetingCamera.prototype, "size", void 0);
if (customElements.get('cat-icon-meeting-camera') === undefined) {
    customElements.define('cat-icon-meeting-camera', BlocksIconMeetingCamera);
}
